// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/img/banner-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright 2025 Paion Data. All rights reserved.
 */
.banner {
  margin-top: 0;
  padding: 260px 0 100px 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
}

.banner .tagline {
  font-weight: 700;
  letter-spacing: 0.8px;
  padding: 8px 10px;
  background: linear-gradient(90.21deg, var(--dark-green) -5.91%, var(--green) 111.58%);
  border: 1px solid rgba(255, 255, 255, 0.5);
  font-size: 20px;
  margin-bottom: 16px;
  display: inline-block;
}

.banner h1 {
  font-size: 65px;
  font-weight: 700;
  letter-spacing: 0.8px;
  line-height: 1;
  margin-bottom: 20px;
  display: block;
  color: var(--green);
}

.banner p {
  color: var(--dark-blue);
  font-size: 18px;
  letter-spacing: 0.8px;
  line-height: 1.5em;
  width: 96%;
}

.banner button {
  color: var(--red);
  font-weight: 700;
  font-size: 20px;
  margin-top: 60px;
  letter-spacing: 0.8px;
  display: flex;
  align-items: center;
}

.banner button svg {
  font-size: 25px;
  margin-left: 10px;
  transition: 0.3s ease-in-out;
  line-height: 1;
}

.banner button:hover svg {
  margin-left: 25px;
}

.banner img {
  animation: updown 3s linear infinite;
}

@keyframes updown {
  0% {
    transform: translateY(-20px);
  }
  50% {
    transform: translateY(20px);
  }
  100% {
    transform: translateY(-20px);
  }
}

.txt-rotate > .wrap {
  border-right: 0.08em solid #666;
}
`, "",{"version":3,"sources":["webpack://./packages/studytour-io-app/src/components/Banner.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;EACE,aAAa;EACb,wBAAwB;EACxB,yDAAoD;EACpD,+BAA+B;EAC/B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,qFAAqF;EACrF,0CAA0C;EAC1C,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":["/**\n * Copyright 2025 Paion Data. All rights reserved.\n */\n.banner {\n  margin-top: 0;\n  padding: 260px 0 100px 0;\n  background-image: url(\"../assets/img/banner-bg.png\");\n  background-position: top center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.banner .tagline {\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  padding: 8px 10px;\n  background: linear-gradient(90.21deg, var(--dark-green) -5.91%, var(--green) 111.58%);\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  font-size: 20px;\n  margin-bottom: 16px;\n  display: inline-block;\n}\n\n.banner h1 {\n  font-size: 65px;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  line-height: 1;\n  margin-bottom: 20px;\n  display: block;\n  color: var(--green);\n}\n\n.banner p {\n  color: var(--dark-blue);\n  font-size: 18px;\n  letter-spacing: 0.8px;\n  line-height: 1.5em;\n  width: 96%;\n}\n\n.banner button {\n  color: var(--red);\n  font-weight: 700;\n  font-size: 20px;\n  margin-top: 60px;\n  letter-spacing: 0.8px;\n  display: flex;\n  align-items: center;\n}\n\n.banner button svg {\n  font-size: 25px;\n  margin-left: 10px;\n  transition: 0.3s ease-in-out;\n  line-height: 1;\n}\n\n.banner button:hover svg {\n  margin-left: 25px;\n}\n\n.banner img {\n  animation: updown 3s linear infinite;\n}\n\n@keyframes updown {\n  0% {\n    transform: translateY(-20px);\n  }\n  50% {\n    transform: translateY(20px);\n  }\n  100% {\n    transform: translateY(-20px);\n  }\n}\n\n.txt-rotate > .wrap {\n  border-right: 0.08em solid #666;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
